<script setup lang="ts"></script>

<template>
  <div class="max-xl:overflow-x-auto max-xl:overflow-y-hidden">
    <!-- disable overflow on desktop so that sticky header can work -->
    <table class="w-full app-table">
      <slot></slot>
    </table>
  </div>
</template>

<style scoped>
  @reference "@/assets/styles/main.css";

  :deep(.app-table) {
    @apply max-md:text-sm bg-white;

    thead {
      @apply z-20 top-16 bg-white xl:sticky;
      /* border-b not working, need to use box-shadow */
      @apply shadow-[inset_0_-1px_0_rgba(0,0,0,1)] shadow-gray-200;
    }

    th {
      @apply py-3 align-bottom font-bold;
    }

    th,
    td {
      @apply px-2 first:max-sm:pl-0 last:max-sm:pr-0 md:px-4 first:md:px-2 last:md:px-2 ;
    }

    td {
      @apply border-b py-3;

      .clickable {
        @apply decoration-info-500 text-left underline decoration-dotted decoration-1 underline-offset-4;
      }

      &.buttons {
        @apply whitespace-nowrap text-right;

        button,
        a {
          @apply p-1 text-gray-500 hover:text-gray-950 disabled:text-gray-200;
        }
      }

      strong {
        @apply font-semibold;
      }
    }

    tr:last-of-type td {
      @apply border-b-0;
    }
  }
</style>
